export default __webpack_public_path__ + "media/images/react_icons/location-4041741533a20703baf2960e7f16e77d.svg";